
/*  Микс для скрытия элементов находящихся в процессе загрузки 
    на самом элементе должен быть изначально установлен opacity = 0 
*/ 


export const LoadFaderMixin = (superClass) => class extends superClass {   
    
    connectedCallback() {
        window.addEventListener('load', this._onWindowLoad.bind(this))
        super.connectedCallback()
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this._onWindowLoad.bind(this))
        super.disconnectedCallback()
    }

    _onWindowLoad() {
        this.style.opacity = 1
    }
}